import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-addEmailForForm',
  templateUrl: './addEmailForForm.component.html',
  styleUrls: ['./addEmailForForm.component.scss'] 
})

export class AddEmailForFormComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;   
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;

  authenticationEmail: string;
  isEmailVerified = false;
  participantEmailId: string
  SubmitBy: string = '';

  constructor(public dialogRef: MatDialogRef<AddEmailForFormComponent>,  
   private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
   
   }            
  
   closePopUp() {
    this.dialogRef.close();
  }

  getEmailVerified() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.authenticationEmail);
    this.isEmailVerified = emailVerified;
  }

  
  verifyEmail(){
    if(this.isEmailVerified){
      this.participantEmailId = this.authenticationEmail;
      this.SubmitBy = this.authenticationEmail;   
      this.dialogRef.close(this.participantEmailId);     
      //this.dialogRef.close();
    }else{
      this.toastr.error('Please enter valid email', '', {
        timeOut: 3000,
      });
    }

  }

 

}
